export const environment = {
    production: false,
    apiUrl: ''  // Vide = utilise le proxy local
};
